(ns nl.mediquest.ui.fn
  (:require
   [clojure.spec.alpha :as s]
   [integrant.core :as ig]
   [re-frame.core :as re-frame]))

(defmethod ig/assert-key :fn/redirect [_k v]
  (assert (s/valid? (s/or :path string? :opts map?) v)))

(defn enabled? [readonly? enabled-when-section user-sections]
  (not (and readonly? (not (contains? user-sections enabled-when-section)))))

(defmethod ig/init-key :fn/redirect [_ opts]
  (if (string? opts)
    #(set! js/window.location.href opts)
    (let [{:redirect/keys [path new-tab? readonly? enabled-when-section]
           :user/keys [sections]} opts
          do-nothing identity]
      (if (enabled? readonly? enabled-when-section sections)
        (if new-tab?
          #(js/window.open path)
          #(set! js/window.location.href path))
        do-nothing))))

(defmethod ig/init-key :fn/modal [_ opts]
  #(re-frame/dispatch [:nl.mediquest.ui.core.modal/set-modal opts]))
